import { ArrowDownTrayIcon, EyeIcon, SparklesIcon } from "@heroicons/react/24/outline";

import { Button, Collapsible, Small, Tooltip } from "@fronterahealth/frontera-ui-components";

import { ReportTemplateSampleStatusEnums } from "@api/graphql/types-and-hooks";

interface TemplateExportActionPanelProps {
  onExport: () => void;
  onDownload: () => void;
  sampleStatus?: ReportTemplateSampleStatusEnums;
  disableSampleButton: boolean;
  sampleInvalidated: boolean;
}

export const TemplateExportActionPanel: React.FC<TemplateExportActionPanelProps> = ({
  onExport,
  onDownload,
  sampleStatus,
  disableSampleButton,
  sampleInvalidated,
}) => {
  // Determine the status (invalidated samples as not completed)
  const status = sampleInvalidated
    ? undefined // Show "Generate Sample"
    : sampleStatus;
  return (
    <div className="preview-template-container bg-white rounded-2xl pt-4 pb-2 pl-4 pr-0 border-limestone-100 border w-full">
      <Collapsible
        defaultOpenState={true}
        headerContent={
          <div className="flex space-x-1 ml-2 items-center">
            <EyeIcon className="h-4 w-5 text-text-secondary stroke-2"></EyeIcon>
            <Small displayType="loud" colorType="primary">
              Preview Template
            </Small>
          </div>
        }
        headerIsClickable={true}
        bodyContent={
          <div className="p-2 w-full flex flex-col grow">
            <Small colorType="secondary" className="mb-5">
              Generate a sample report to see how your template will look with placeholder data when creating actual
              client reports
            </Small>
            <Tooltip
              showInfoIcon={false}
              disabled={!disableSampleButton}
              placement="top"
              text="Please save your template before generating a sample"
            >
              <Button
                style={{ width: "100%", minWidth: "100%" }}
                text={
                  (status as unknown as ReportTemplateSampleStatusEnums) ===
                  ReportTemplateSampleStatusEnums.Completed ? (
                    <div className="flex items-center justify-center h-full w-full text-rio-700">
                      <ArrowDownTrayIcon className="mr-2 h-4 w-4 stroke-2" />
                      <Small colorType="primary" className="text-rio-700 text-sm">
                        Download Sample
                      </Small>
                    </div>
                  ) : (status as unknown as ReportTemplateSampleStatusEnums) ===
                    ReportTemplateSampleStatusEnums.Generating ? (
                    <div className="flex items-center justify-center h-full w-full text-rio-700">
                      <SparklesIcon className="mr-2 h-4 w-4" />
                      <Small colorType="primary" className="text-rio-700 text-sm">
                        Generating...
                      </Small>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-full w-full text-rio-700">
                      <Small colorType="primary" className="text-rio-700 text-sm">
                        Generate Sample
                      </Small>
                    </div>
                  )
                }
                appearance="secondary"
                className="ring-rio-400 flex items-center w-full justify-center -ml-2"
                onClick={
                  (status as unknown as ReportTemplateSampleStatusEnums) === ReportTemplateSampleStatusEnums.Completed
                    ? onDownload
                    : (status as unknown as ReportTemplateSampleStatusEnums) ===
                        ReportTemplateSampleStatusEnums.Generating
                      ? undefined
                      : onExport
                }
                disabled={disableSampleButton}
              />
            </Tooltip>
          </div>
        }
      />
    </div>
  );
};
